export class LogLevelDisplayConfig {
  public color: string;
  public icon: string;
  public displayName: string;

  /**
   *
   */
  constructor(color: string, icon: string, displayName: string) {
    this.color = color;
    this.icon = icon;
    this.displayName = displayName;
  }
}
